import PropTypes from 'prop-types';
import { css } from '@emotion/react';

import { tabletUp, desktopUp } from 'styles/utils';

const verticalRhythmCss = (mobileMargin, tabletMargin, desktopMargin) => css`
  ${mobileMargin &&
  css`
    margin-bottom: ${mobileMargin}px;
  `}

  ${tabletMargin &&
  css`
    ${tabletUp} {
      margin-bottom: ${tabletMargin}px;
    }
  `}

  ${desktopMargin &&
  css`
    ${desktopUp} {
      margin-bottom: ${desktopMargin}px;
    }
  `}
`;

/**
 * Add bottom margin at different screen sizes.
 * Mainly should be used for page layout.
 *
 * @param {object} props
 */
function VerticalRhythm({
  className,
  children,
  component: Component = 'section',
  mobileUp,
  tabletUp,
  desktop,
}) {
  return (
    <Component
      css={verticalRhythmCss(mobileUp, tabletUp, desktop)}
      className={className}
    >
      {children}
    </Component>
  );
}

VerticalRhythm.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  /**
   * The component used for the root node.
   * Either a string to use a DOM element or a React component.
   */
  component: PropTypes.elementType,
  /* Margin from bottom on mobile and above */
  mobileUp: PropTypes.number,
  /* Margin from bottom on tablet and above */
  tabletUp: PropTypes.number,
  /* Margin from bottom on desktop and above */
  desktop: PropTypes.number,
};

export default VerticalRhythm;
